import { useEffect } from 'react';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import { observer } from 'mobx-react';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import Home from 'Views/Components/_HumanWritten/Home/Home';
import { store } from 'Models/Store';
import MarketingBanner from '../Components/_HumanWritten/MarketingBanner';
import { HOME_PAGE_TITLE } from 'ConstantPageNames';

export interface HomePageProps {}

export function HomePage() {
	useEffect(() => {
		document.title = HOME_PAGE_TITLE;
	}, []);

	// `contactus` arrives in the query string (/home?contactus=true), not as a route segment.
	const [searchParams] = useSearchParams();
	const contactUs = searchParams.get('contactus') === 'true';

	return (
		<SecuredPage>
			<NavigationWrapper />
			<div className="body-content">
				<Home contactUs={contactUs} />
				<div className="absolute-position">
					{/* <PoweredByFerryHawk /> */}
					{!store.isManager && <MarketingBanner />}
				</div>
			</div>
		</SecuredPage>
	);
}

export default observer(HomePage);
